import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Wizard } from '@xengage/gw-portals-wizard-react';
import { Loader } from '@jutro/components';
import { withRouter } from 'react-router-dom';

import { QuoteInfoComponentContext } from 'gw-capability-quoteandbind-common-react';
import LobQuoteInfo from './components/LobQuoteInfo/LobQuoteInfo';
import './CodegenWizard.messages';
import { CodegenContext } from './components/CodegenContext';
import { useWizardInit, useWizardExit } from './hooks';


function CodegenWizard(props) {
    const { location, match, history } = props;
    const pathParams = match.url.split('/');
    const productCode = pathParams[1];
    const { submission, address, externalPresentationMetadata } = location.state;
    const {
        submissionVM,
        isFetchingWizardSteps,
        wizardSteps,
        wizardTitle,
        presentationMetadata,
        isCreatingSubmission
    } = useWizardInit({
        productCode,
        address,
        submission,
        externalPresentationMetadata
    });
    const [isWizardExiting, setWizardExiting] = useWizardExit(history);

    const lobData = _.get(submissionVM, 'lobData.value');
    const firstAvailableLob = lobData && Object.keys(lobData)[0];
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    const codegenContext = {
        presentationMetadata,
        lineName: firstAvailableLob,
        lobName: productCode,
        productCode
    };

    const hasRetrievedSubmission = !_.isUndefined(submission);

    const isStatusQuoted = _.get(submissionVM, 'baseData.periodStatus.value.code') === 'Quoted';


    return isCreatingSubmission || isWizardExiting || isFetchingWizardSteps
        ? <Loader />
        : (
            <QuoteInfoComponentContext.Provider value={LobQuoteInfo}>
                <CodegenContext.Provider value={codegenContext}>
                    <Wizard
                        initialSteps={wizardSteps}
                        wizardTitle={wizardTitle}
                        initialData={submissionVM}
                        onCancel={setWizardExiting}
                        skipCompletedSteps={isStatusQuoted}
                    />
                </CodegenContext.Provider>
            </QuoteInfoComponentContext.Provider>
        );
}

CodegenWizard.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({
            address: PropTypes.shape({}),
            submission: PropTypes.shape({}),
            externalPresentationMetadata: PropTypes.shape({}) // optional prop. Usually undefined
        })
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired,
    match: PropTypes.shape({
        url: PropTypes.string
    }).isRequired
};

export default withRouter(CodegenWizard);
